<template>
  <div>
    <el-row class="mb-2" :gutter="24" v-if="showIndicators">
      <el-col :xs="12" :sm="12" :lg="6" v-if="isColombia">
        <stats-card
          v-bind:title="dolar[1]"
          :subTitle="$t('common_words.dollar')"
          class="card-home"
        >
          <div slot="header" class="icon-success">
            <img
              alt=""
              style="width: 55px"
              src="/static/img/iconos/dolar.svg"
            />
            <em v-bind:class="dolar[0]" class="icon-indicators mr-2"></em>
          </div>
          <template slot="footer">
            <em class="fa fa-refresh footer-pki-size"></em>
            <span class="footer-pki-size">
              {{ $t('common_words.temporal1') }}
            </span>
          </template>
        </stats-card>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" v-if="isColombia">
        <stats-card
          v-bind:title="euro[1]"
          :subTitle="$t('common_words.euro')"
          class="card-home"
        >
          <div slot="header" class="icon-success">
            <img alt="" style="width: 55px" src="/static/img/iconos/euro.svg" />
            <em v-bind:class="euro[0]" class="icon-indicators mr-1"></em>
          </div>
          <template slot="footer">
            <em class="fa fa-refresh footer-pki-size"></em>
            <span class="footer-pki-size">
              {{ $t('common_words.temporal1') }}
            </span>
          </template>
        </stats-card>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" v-if="isColombia">
        <stats-card
          v-bind:title="cafe[1]"
          :subTitle="$t('common_words.coffee')"
          class="card-home"
        >
          <div slot="header" class="icon-success">
            <img alt="" style="width: 55px" src="/static/img/iconos/cafe.svg" />
            <em v-bind:class="cafe[0]" class="icon-indicators"></em>
          </div>
          <template slot="footer">
            <em class="fa fa-refresh footer-pki-size"></em>
            <span class="footer-pki-size">
              {{ $t('common_words.temporal1') }}
            </span>
          </template>
        </stats-card>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" style="cursor: pointer">
        <div @click="handleViewCalendar">
          <stats-card
            v-bind:title="formatCalendarName"
            :subTitle="$t('common_words.calendar')"
            class="card-home"
          >
            <div slot="header" class="icon-danger">
              <img
                alt=""
                style="width: 55px"
                src="/static/img/iconos/icono-color-calendario.svg"
              />
            </div>
            <template slot="footer">
              <em class="fa fa-refresh footer-pki-size"></em>
              <span class="footer-pki-size"> {{ currentDateCalendar }} </span>
            </template>
          </stats-card>
        </div>
      </el-col>
      <calendar-modal
        @calendarName="setCalendarName"
        @showHideLoading="showHideLoading"
        ref="calendarModal"
      ></calendar-modal>
    </el-row>
    <div class="row" :key="widgetsHeight">
      <div
        v-for="widget in widgets"
        :key="widget.id"
        class="col-md-12 col-lg-6"
      >
        <component
          :is="widget.component_name"
          @hideLoading="showHideLoading"
          :height="widgetsHeight"
        />
      </div>
    </div>
    <!-- Grafica las dashboards que no es mas que un cumulo de graficas en una sola vista -->
    <div class="row mt-4" v-if="dashboards.length > 0">
      <div v-for="dashboard in dashboards" :key="dashboard.id" class="col-12">
        <component
          :is="dashboard.component_name"
          @hideLoading="showHideLoading"
          :height="widgetsHeight"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Avatar, Card, Slider, Tooltip, Row, Col } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import { StatsCard } from 'src/components/index';
import axios from 'axios';
import BoxByFarmChart from './components/Boxes/BoxByFarmChart.vue';
import CalendarModal from 'src/views/Pages/Dashboard/CalendarModal/CalendarModal.vue';
import ClimateCarousel from './components/Climate/ClimateCarousel.vue';
import ColumnChartCompliance from './components/Quality/ColumnChartCompliance.vue';
import ColumnChartTotalQualities from './components/Quality/ColumnChartTotalQualities.vue';
import DiseasesBarChart from './components/Diseases/DiseasesBarChart.vue';
import DiseasesPieChart from './components/Diseases/DiseasesPieChart.vue';
import SecurityDashboard from './components/GrowDashboard/SecurityDashboard.vue';
import ExternalQualityDashboard from './components/GrowDashboard/ExternalQualityDashboard.vue';
import exportingInit from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';
import HomeStationMap from './components/GIS/Stations/HomeStationMap.vue';
import i18n from 'src/i18n';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinCharts from 'src/util/mixinCharts';
import mixinLocation from 'src/util/mixinLocation';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import mixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import Vue from 'vue';
import VueScreen from 'vue-screen';
import VueTabs from 'vue-nav-tabs';

Vue.use(VueScreen, {
  xs: '300px',
  '2xs': '400px',
  '3xs': '500px',
  sm: '568px',
  '2sm': '600px',
  md: '768px',
  '2md': '800px',
  lg: '992px',
  '2lg': '1100px',
  xl: '1200px',
  '2xl': '1300px',
  '3xl': '1400px',
  '4xl': '1500px',
  '5xl': '1600px',
  '6xl': '1700px',
  '7xl': '1800px',
  '8xl': '1880px',
});

exportingInit(Highcharts);

export default {
  components: {
    StatsCard,
    CalendarModal,
    [VueTabs.name]: VueTabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card,
    [Slider.name]: Slider,
    [Tooltip.name]: Tooltip,
    [Avatar.name]: Avatar,
    BoxByFarmChart,
    ClimateCarousel,
    DiseasesBarChart,
    DiseasesPieChart,
    HomeStationMap,
    ColumnChartCompliance,
    ColumnChartTotalQualities,
    SecurityDashboard,
    ExternalQualityDashboard,
  },
  data() {
    return {
      dolar: [],
      euro: [],
      cafe: [],
      calendarName: 'Calendario',
      showIndicators: false,
      currentDate: moment().format('DD/MM/YYYY'),
      currentTime: moment().format('hh:mm:ss'),
      currentYear: moment().format('YYYY'),
      tomorrowDate: moment().add(1, 'days').format('DD/MM/YYYY'),
      marks: {
        10: '10°C',
        20: '20°C',
        30: '30°C',
        40: '40°C',
        50: '50°C',
      },
      widgets: [],
      dashboards: [],
      intervalId: null,
      widgetsHeight: 500,
      breakpoints: {
        xs: 1120,
        '2xs': 920,
        '3xs': 920,
        sm: 820,
        '2sm': 820,
        md: 768,
        '2md': 820,
        lg: 940,
        '2lg': 870,
        xl: 720,
        '2xl': 640,
        '3xl': 640,
        '4xl': 600,
        '5xl': 600,
        '6xl': 600,
        '7xl': 540,
        '8xl': 520,
      },
    };
  },

  mixins: [
    MixinArcgisMap,
    MixinCharts,
    mixinMasters,
    MixinMenu,
    MixinNumbers,
    mixinPermissions,
    mixinLocation,
  ],
  watch: {
    '$screen.breakpoint'() {
      this.changeWidgetsHeigh();
    },
  },
  computed: {
    formatCalendarName() {
      return this.calendarName.replace(i18n.t('common_words.calendar'), '');
    },
    currentDateCalendar() {
      return moment().locale(i18n.locale).format('ll');
    },

    currentDay: () => {
      return moment().locale(i18n.locale).format('dddd');
    },
    isColombia() {
      if (this.center && this.center.lat && this.center.lng) {
        const lat = this.center.lat;
        const lng = this.center.lng;
        if (lat >= -4.5 && lat <= 13.5 && lng >= -82.0 && lng <= -66.0) {
          return true;
        }
      }
      const user = this.$store.state.auth.user;
      if (user && user.business) {
        return user.business.some(
          (b) => b.country && b.country.trim().toLowerCase() === 'colombia'
        );
      }
      return false;
    },
  },
  methods: {
    changeWidgetsHeigh() {
      this.widgetsHeight = this.breakpoints[this.$screen.breakpoint];
    },
    handleViewCalendar() {
      this.$refs.calendarModal.setOpen(true);
    },
    setCalendarName(calendarName) {
      this.calendarName = calendarName;
    },
    setArrow(data) {
      switch (data) {
        case 'sube':
          return 'fa fa-arrow-up text-success';
        case 'baja':
          return 'fa fa-arrow-down text-danger';
        case 'igual':
          return 'fa fa-arrow-right text-warning';
      }
    },
    getIndicators() {
      axios.get('/auth/indicators/').then((response) => {
        this.dolar[0] = this.setArrow(response.data[0]);
        this.dolar[1] = response.data[1];
        this.euro[0] = this.setArrow(response.data[2]);
        this.euro[1] = response.data[3];
        this.cafe[0] = this.setArrow(response.data[4]);
        this.cafe[1] = response.data[5];
        this.currentTime = moment().format('hh:mm:ss');
        this.showIndicators = true;
      });
    },
    async getUserWidgets() {
      return Axios.getMasters('widgets/indexbyuser')
        .then((response) => {
          this.widgets = response.data.data;
          this.showHideLoading();
          this.getDashboards();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    getDashboards() {
      //Este array contendra los widget de graficas que no seran presentados como un widget
      //si no un tablero completo, cada vez que se cree uno nuevo, debe registrarse aqui
      const dashboardsNames = ['SecurityDashboard', 'ExternalQualityDashboard'];
      //obtengo solo los widgets individuales
      const widgets = this.widgets.filter((wdgt) => {
        return !dashboardsNames.includes(wdgt.component_name);
      });
      //obtengo solo los dashboards
      const dashboards = this.widgets.filter((wdgt) => {
        return dashboardsNames.includes(wdgt.component_name);
      });
      this.$set(this, 'widgets', widgets);
      this.$set(this, 'dashboards', dashboards);
    },
  },
  async mounted() {
    this.showHideLoading(true);
    this.selectedItemOnMenu('home');
    if (this.isIndex()) {
      try {
        await Promise.race([
          this.getPosition(),
          new Promise((resolve) => setTimeout(resolve, 3000)),
        ]);
      } catch (e) {
        console.error(e);
      }
      if (this.isColombia) {
        await this.getIndicators();
        this.intervalId = setInterval(() => this.getIndicators(), 3600000);
      } else {
        this.showIndicators = true;
      }
      await this.getUserWidgets();
      this.changeWidgetsHeigh();
    } else {
      this.showHideLoading();
    }
  },
  destroyed() {
    clearInterval(this.intervalId);
    this.deselectedItemOnMenu('home');
  },
};
</script>
<style scoped>
.custom-title {
  font-family: 'Montserrat', 'Lucida Grande', 'Lucida Sans Unicode', Arial,
    Helvetica, sans-serif;
}
.custom-subtitle {
  font-family: 'Montserrat', 'Lucida Grande', 'Lucida Sans Unicode', Arial,
    Helvetica, sans-serif;
  font-size: 12px;
}
@media (max-width: 991px) {
  .custom-margin {
    margin-top: 20px;
  }
}
</style>
<style>
/* .custom-opacity {
  opacity: 0.99;
} */
.home-card .card-footer {
  padding: 0px !important;
}
.highcharts-axis-labels text {
  text-decoration: none !important;
}
.highcharts-drilldown-axis-label {
  color: #74696b !important;
  fill: #74696b !important;
  font-weight: bold !important;
}
.highcharts-drilldown-data-label text {
  color: #74696b !important;
  fill: #74696b !important;
  font-weight: bold !important;
}
.highcharts-data-labels text {
  text-decoration: none !important;
}
</style>
